/*:: type Debug = {
  calls: Array<{
    key: string,
    in: Object,
    out: Object,
    success: boolean
  }>
};*/

class SocialPost {
  constructor({
    id,
    state,
    displayState,
    groupId,
    scheduledDate,
    lastNotified,
    postFormat,
    input,
    output,
    relatedEntities,
    meta,
    socialNetwork,
    socialNetworkUrl,
    campaignName,
    contentType,
    errorCode,
    errorMessage,
    variables,
    debug,
    canModify,
    canRegenerate
  }) {
    this.id = id;
    this.state = state;
    this.displayState = displayState;
    this.groupId = groupId;
    this.scheduledDate = scheduledDate;
    this.lastNotified = lastNotified;
    this.postFormat = postFormat;
    this.input = input;
    this.output = output;
    this.relatedEntities = relatedEntities;
    this.meta = meta;
    this.socialNetwork = socialNetwork;
    this.socialNetworkUrl = socialNetworkUrl;
    this.campaignName = campaignName;
    this.contentType = contentType;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.variables = variables;
    this.debug = debug;
    this.canModify = canModify;
    this.canRegenerate = canRegenerate;
  }

} // eslint-disable-next-line arrow-body-style


SocialPost.parse = (json
/*: Object*/
) =>
/*: SocialPost*/
{
  return new SocialPost({
    id: json.id,
    state: json.state,
    displayState: json.displayState,
    groupId: json.groupId,
    scheduledDate: json.scheduledDate,
    lastNotified: json.lastNotified,
    postFormat: json.postFormat,
    input: json.input,
    output: json.output,
    relatedEntities: json.relatedEntities,
    meta: json.meta,
    socialNetwork: json.socialNetwork,
    socialNetworkUrl: json.socialNetworkUrl,
    campaignName: json.campaignName,
    contentType: json.contentType,
    errorCode: json.error && json.error.code,
    errorMessage: json.error && json.error.message,
    variables: json.variables,
    debug: json.debug,
    canModify: json.canModify,
    canRegenerate: json.canRegenerate
  });
}; // eslint-disable-next-line arrow-body-style


SocialPost.serialize = (data
/*: SocialPost*/
) =>
/*: Object*/
{
  return {
    id: data.id,
    scheduledDate: data.scheduledDate,
    output: data.output
  };
};

module.exports = SocialPost;